import { useTranslation } from 'react-i18next';

import { Label } from './refresh-filter.styled';

export const RefreshFilter = (props) => {
  const { t } = useTranslation();
  const { value, change, title: titleProp } = props;

  const title = titleProp || t('buttons.Автообновление');

  return (
    <Label>
      <input type="checkbox" checked={value} onChange={change} />
      <span>{title}</span>
    </Label>
  );
};
